import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import { getUrl } from "../../routes/apiEndPoints";

// fetch-dynamic-pages-list
export const fetchList = createAsyncThunk("fetch-dynamic-pages-list", async (props) => {
    try {
        const {routeName} = props
        const apiURL = getUrl(routeName);
      const response = await API_REQUEST({
        url: apiURL,
        method: "GET",
        isErrorToast: false,
      });
      return response;
    } catch (error) {}
  });